// extracted by mini-css-extract-plugin
export default {"page":"forgot-password_page__NFtGD","form":"forgot-password_form__R3i8M","center":"forgot-password_center__PIAT5","textRow":"forgot-password_textRow__BMpnB"};